module.exports = __webpack_public_path__ + "static/urban3-5acb244edb24484ea3f910326b4b2e18.jpg";